import { createRequestFn } from '../analytics/util'
import View from '../analytics'
import Models from '../analytics/models'
import queryString from 'query-string'
import QueryString from '../utils/QueryString';
var React = require('react');
var xtend = require('xtend');
var parallel = require('run-parallel');
var moment = require('moment');
// var util = require('../analytics/util')
// var Models = require('../analytics/models')
var { createState, PendingQuery } = Models
var noop = function () {}

var defer = (typeof Promise === 'function') ?
    Promise.resolve().then.bind(Promise.resolve()) :
    window.setTimeout


function analyticsRoute (api, socket, opts) {
    var qs = queryString.parse(window.location.search);
    var request = createRequestFn({ clientID: opts.credentials.clientID })

    var io = {
        /* getViewerCounts: request('/stats/getViewerCounts'),
        getTopDevices: request('/stats/getTopPlatform'),
        getTopOS: request('/stats/getTopOS'),
        getTopBrowsers: request('/stats/getTopBrowsers'),
        getAvgPlayLen: request('/stats/getAvgPlayLen'),
        getTopStates: request('/stats/getTopStates'),
        getTopCities: request('/stats/getTopCities'),
        getTopReferrers: request('/stats/getTopReferrers'),
        getViewerSessions: request('/stats/getViewerSessions'),
        getMostWatched: request('/stats/getMostWatched') */
    }

    if (process.env.NODE_ENV === 'development') {
        window.io = io
    }

    var defaultQuery = {
        startDate: moment().startOf('month').format('YYYY-MM-DD'),
        endDate: moment().endOf('month').format('YYYY-MM-DD'),
        category: null
    }

    var models = Models({ eventID: queryString.parse(window.location.search).eventID, io, api })
    var state = createState(models, { defaultQuery })

    // fetch all the stuff


    function getEventData () {
        models.event.get({
            eventID: queryString.parse(window.location.search).eventID,
            includePrivate: true
        }, function (err, res) {
            var event = res.data[0]
            if (!event) return

            var _query = {
                startDate: moment(event.startDateTime)
                    .format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                eventID: queryString.parse(window.location.search).eventID
            }
        })
    }

    var eventHandlers = {
        onQuerySubmit: function (ev) {
            preventDefault(ev)
            var pendingQuery = state.pendingQuery()
            QueryString.set({})

            state.isFetchPending.set(true)
        },

        onDateChange: function (ev) {
            var { type, value } = ev
            var _update = {}
            _update[type] = value
            PendingQuery.set(state.pendingQuery, _update)
        },

        onQuickDatesChange: function (quarter) {
            PendingQuery.set(state.pendingQuery, quarter)
        },

        onCategorySelect: function (ev) {
            preventDefault(ev)
            PendingQuery.set(state.pendingQuery, {
                category: ev
            })
        }
    }

    class AnalyticsComponent extends React.Component {
        constructor (props) {
            super(props)
            this.state = state()
        }

        componentDidMount () {
            var self = this
            var _update
            var isPending = false

            this._unsubscribe = state(function onChange (_state) {
                _update = _state
                // batch any synchronous calls to setState
                if (!isPending) defer(() => {
                    self.setState(_update)
                    isPending = false
                })
                isPending = true
            })

            if (queryString.parse(window.location.search).eventID) return getEventData()
        
        }

        componentWillUnmount () {
            this._unsubscribe()
        }

        render () {
            return <div className="analytics-route">
                <View
                    {...this.state}
                    {...eventHandlers}
                    queryString={queryString.parse(window.location.search)}
                    client={opts.credentials.client}
                    user={opts.credentials.user}
                />
            </div>
        }
    }

    return () => {
        return <AnalyticsComponent/>
    }
}

export default analyticsRoute

function preventDefault (ev) {
    try {
        ev.preventDefault()
    } catch (err) { /* ok */ }
}


